import React from 'react';

/** Round header chip (mobile's note-screen Chip); `active` fills it with ink. */
export const HeaderChip: React.FC<{
  icon: React.ComponentType<{ size?: number }>;
  label: string;
  onClick: () => void;
  active?: boolean;
}> = ({ icon: Icon, label, onClick, active }) => (
  <button
    type="button"
    onClick={onClick}
    aria-label={label}
    title={label}
    aria-pressed={active}
    className={`flex h-[38px] w-[38px] cursor-pointer items-center justify-center rounded-full border-none transition-[transform,background] duration-150 active:scale-90 ${
      active ? 'bg-primary text-on-primary' : 'bg-surface-container-low text-on-surface hover:bg-surface-container'
    }`}
  >
    <Icon size={18} />
  </button>
);
